import FullHdShadowIcon from 'assets/icons/photo/FullHdShadowIcon'

const photoActions = {
  hdIcon: () => FullHdShadowIcon,
}

export default photoActions
